import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { WiCloudy, WiDayHaze, WiDaySunny, WiRainMix, WiThunderstorm, WiRain } from "weather-icons-react";
import {
    useFonts,
    Roboto_100Thin,
    Roboto_100Thin_Italic,
    Roboto_300Light,
    Roboto_300Light_Italic,
    Roboto_400Regular,
    Roboto_400Regular_Italic,
    Roboto_500Medium,
    Roboto_500Medium_Italic,
    Roboto_700Bold,
    Roboto_700Bold_Italic,
    Roboto_900Black,
    Roboto_900Black_Italic,
} from '@expo-google-fonts/roboto';
import { useSelector, useDispatch } from 'react-redux';
export default function MainWeather() {
    // We are getting data from Redux in this file
    var data = useSelector(state => state.weather);



    var city_name = "London";
    ////////////////////////////////////////////////////////////
    //For date and time!!!
    var time = new Date();

    var time = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var d = new Date();
    var dayName = days[d.getDay()];
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sepr", "Oct", "Nov", "Dec"];
    const dateObj = new Date();
    const month = monthNames[dateObj.getMonth()];
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();
    const output = month + '\n' + day + ',' + year;
    //////////////////////////////////////////////////////////
    const m = d.toLocaleString('default', { month: 'long' }).substr(0, 3);
const da = d.getDate();
const y = d.getFullYear().toString().substr(2, 2);

const formattedDate = `${da} ${m} '${y}`;
    function float2int(value) {
        return value | 0;
    }
    if (data.name === "Bangshal") {
        city_name = "Dhaka";
    }
    else {
        city_name = data.name;
    }

    return (
        <View style={styles.main_wrapper}>
            <View style={styles.temperature_con}>
                <Text style={styles.temperature_value}>{float2int(data.main.temp)}°</Text> 
                
                <View style={styles.location_and_time}>
                    <View>
                        <Text style={styles.city_name}>{city_name}</Text>
                        <Text style={styles.time}>{time} - {dayName}, {formattedDate}</Text>

                    </View>
                    <View style={{ marginTop: -15 }}>
                        {(() => {
                            if (data.weather[0].main === 'Clouds') {
                                return (
                                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <WiCloudy size={150} color='#fff' />
                                        <Text style={styles.weather_condition}>Cloudy</Text>
                                    </View>
                                );
                            }
                            else if (data.weather[0].main === 'Clear') {
                                return (
                                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <WiDaySunny size={150} color='#fff' />
                                        <Text style={styles.weather_condition}>Clear</Text>
                                    </View>
                                );
                            }
                            else if (data.weather[0].main === 'Rain') {
                                return (
                                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <WiRain size={140} color='#fff' />
                                        <Text style={styles.weather_condition}>Rain</Text>
                                    </View>
                                );
                            }
                            else if (data.weather[0].main === 'Thunderstorm') {
                                return (
                                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <WiThunderstorm size={150} color='#fff' />
                                        <Text style={styles.weather_condition}>Thunderstorm</Text>
                                    </View>
                                );
                            }
                            else if (data.weather[0].main === 'Drizzle') {
                                return (
                                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <WiRainMix size={150} color='#fff' />
                                        <Text style={styles.weather_condition}>Drizzle</Text>
                                    </View>
                                );
                            }
                            else if (data.weather[0].main === 'Haze') {
                                return (
                                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <WiDayHaze size={150} color='#fff' />
                                        <Text style={styles.weather_condition}>Haze</Text>
                                    </View>
                                );
                            }

                        })()}

                    </View>

                </View>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    main_wrapper: {
        width: 600,
        height: 150,
        //backgroundColor: "#000",
        //borderWidth: 5,
        //borderColor: "#fff",
        position: "absolute",
        left: 120,
        bottom: 125
    },
    temperature_con: {
        width: 190,
        height: 150,
        //borderWidth: 1,
        //borderColor: "#fff",
        position: "absolute",
        left: 0,
        flexDirection: 'row',
    },
    temperature_value: {
        color: "#fff",
        fontFamily: 'Roboto_400Regular',
        fontSize: 120,
    },
    location_and_time: {
        width: 464,
        height: 150,
        //borderWidth: 1,
        //borderColor: "#fff",
        marginLeft: 20,
        flexDirection: 'row',
    },
    city_name: {
        color: "#fff",
        fontFamily: 'Roboto_400Regular',
        fontSize: 80,
        marginTop: 3,
    },
    time: {
        color: "#fff",
        fontFamily: 'Roboto_100Thin',
        fontSize: 25,
    },
    weather_condition: {
        color: "#fff",
        fontFamily: 'Roboto_100Thin',
        fontSize: 25,
        marginTop: -15,
    }

})
